import { ESessionStorage } from '@/types/storage';

export const ReturnTo = {
  set(v: string) {
    sessionStorage.setItem(ESessionStorage.RT_KEY, v);
  },
  peek(): string | null {
    return sessionStorage.getItem(ESessionStorage.RT_KEY);
  },
  clear() {
    sessionStorage.removeItem(ESessionStorage.RT_KEY);
  },
};

const pendingRedirectListeners = new Set<() => void>();

// useSyncExternalStore calls getSnapshot on every render and again to check for
// tearing, so the value is cached to keep it a plain read instead of a storage hit.
let pendingRedirectSnapshot: string | null | undefined;

const notifyPendingRedirectListeners = () => {
  pendingRedirectListeners.forEach(listener => listener());
};

export const PendingRedirect = {
  set(v: string) {
    sessionStorage.setItem(ESessionStorage.PR_KEY, v);
    pendingRedirectSnapshot = v;
    notifyPendingRedirectListeners();
  },
  peek(): string | null {
    if (pendingRedirectSnapshot === undefined) {
      pendingRedirectSnapshot = sessionStorage.getItem(ESessionStorage.PR_KEY);
    }

    return pendingRedirectSnapshot;
  },
  clear() {
    sessionStorage.removeItem(ESessionStorage.PR_KEY);
    pendingRedirectSnapshot = null;
    notifyPendingRedirectListeners();
  },
  subscribe(listener: () => void) {
    pendingRedirectListeners.add(listener);

    return () => {
      pendingRedirectListeners.delete(listener);
    };
  },
};
